var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131313",
    d: "M9.36 9.237a.7.7 0 0 0-.123.124A4.65 4.65 0 0 1 6 10.667 4.65 4.65 0 0 1 2.7 9.3 4.65 4.65 0 0 1 1.333 6 4.65 4.65 0 0 1 2.7 2.7 4.65 4.65 0 0 1 6 1.333 4.65 4.65 0 0 1 9.3 2.7 4.65 4.65 0 0 1 10.667 6 4.65 4.65 0 0 1 9.36 9.237m3.778 2.958-2.45-2.45A5.98 5.98 0 0 0 12 6a5.98 5.98 0 0 0-1.757-4.243A5.98 5.98 0 0 0 6 0a5.98 5.98 0 0 0-4.243 1.757A5.98 5.98 0 0 0 0 6c0 1.657.672 3.157 1.757 4.243A5.98 5.98 0 0 0 6 12a5.98 5.98 0 0 0 3.745-1.312l2.45 2.45a.666.666 0 1 0 .943-.943"
  })));
};
export default SvgSearch;